import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import TogglerBody from '../../TogglerBody';
import {RxCross1} from 'react-icons/rx';
import TipsTamplate from '../../TipsTamplate';
import './whiteList.scss';
import SearchDropdown from '../../SearchDropdown/SearchDropdow';
import SearchDropdownBtn from '../../SearchDropdown/SearchDropdownBtn';
import SquareIcon from '../../SquareIcon/SquareIcon';
import {useChanges} from '../../../../hooks/useChanges';

const WhiteListComponent = ({data}) => {
  const {addChangeToStore} = useChanges();
  const [isUseWhitelist, setIsUseWhitelist] = useState(data?.data?.useWL);
  const [inputValueUser, setInputValueUser] = useState('');
  const [showBtnUser, setShowBtnUser] = useState(true);
  const {membersGlobalState} = useSelector((state) => state.members);
  const [wlUsers, setWlUsers] = useState(data?.data?.wlUsers || []);
  const {rolesGlobalState} = useSelector((state) => state.roles);

  // const [wlRoles, setWlRoles ] = useState(data?.data?.wlRoles || []);

  // const addNewRoleAdmin = () => {
  //   const newRole = {
  //     name: inputValue,
  //     color: "",
  //     img: "",
  //   };
  //   setWlRoles((prev) => [...prev, newRole]);
  //   setInputValue("");
  //   addChangeToStore({ key: "wlRoles", value: [...wlRoles, newRole] })
  // };

  // const handleKeyPressAdmin = (e) => {
  //   if (inputValue && e.key === "Enter") {
  //     addNewRoleAdmin();
  //   }
  // };

  // const deleteRole = (index) => {
  //   const updatedRoles = wlRoles.filter((role, idx) => idx !== index);
  //   setWlRoles(updatedRoles);
  //   addChangeToStore( { key: "wlRoles", value: updatedRoles })

  // };

  const addUser = (obj) => {
    const userExists = wlUsers.some((user) => user.id === obj.id);
    if (!userExists) {
      setWlUsers((prevUsers) => [...prevUsers, obj]);
      addChangeToStore({key: 'wlUsers', value: [...wlUsers, obj]});
    }
    setInputValueUser('');
  };

  const deleteUser = (id) => {
    const updatedUsers = wlUsers.filter((user) => user.id !== id);
    setWlUsers(updatedUsers);
    addChangeToStore({key: 'wlUsers', value: updatedUsers});
  };

  return (
    <div className="white_list_block_wrap">
      <div className="white_list_block_wrap_bg"></div>
      <SquareIcon
        squareFirstClassname={'first_square_bg_lightblue '}
        squareSecondClassname={'second_square_bg_lightblue'}
        imgSrc={'/img/WhitelistIcon.svg'}
      />
      <h3>Whitelist</h3>
      <div className="white_list_block_item" style={{borderBottom: '1px solid #8D99A3'}}>
        <div className="white_list_block_item_toggler">
          <TogglerBody isOn={isUseWhitelist} setIsOn={setIsUseWhitelist} keyName={'useWL'} />
          <p>Use Whitelist</p>
        </div>
      </div>
      <div className="white_list_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">Whitelist Roles:</p>
          <TipsTamplate
            title={'Whitelist Roles'}
            label={'Safe'}
            text={
              '<p>Define roles that are allowed to create web-hooks, ensuring controlled access.</p>'
            }
            textSecond={'<p>Themis will ignore web-hooks created by specified roles.</p>'}
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap">
          {rolesGlobalState?.data?.roles?.map((item, idx) => (
            <div
              key={idx}
              className="access_component_user_one white_list_block_item_user_one"
              style={{
                border: `1.5px solid ${item?.hex}`,
                background: `${item?.hex}42`,
              }}>
              {item?.hex && (
                <div
                  className="access_component_user_one_color"
                  style={{background: `${item?.hex}`}}></div>
              )}
              <p style={{color: `${item?.hex}`}}>{item.name}</p>
              {/* <span
                className="access_component_user_one_delete-icon"
                // onClick={() => deleteRole(idx)}
              >
                <RxCross1 />
              </span> */}
            </div>
          ))}
          {/* <input
            type="text"
            placeholder="..."
            value={inputValue}
            onChange={(e) => {
              setInputValue(e.target.value);
            }}
            onKeyPress={handleKeyPressAdmin}
          /> */}
        </div>
        <div className="setting_component_item_alert">
          <img src="/img/info.svg" alt="" />
          <p>Any role with the Administrator permission is considered as a bot master.</p>
        </div>
      </div>
      <div className="white_list_block_item">
        <div className="white_list_block_item_title_block">
          <p className="white_list_block_item_title">Whitelist Users:</p>
          <TipsTamplate
            title={'Whitelist Users'}
            label={'Safe'}
            text={
              '<p>Define users or bots that are allowed to create web-hooks, ensuring controlled access.</p>'
            }
            textSecond={'<p>Themis will ignore web-hooks created by specified users or bots.</p>'}
          />
        </div>
        <div className="white_list_block_item_arr_user_wrap">
          {wlUsers &&
            wlUsers?.map((item, idx) => (
              <div key={idx} className="access_component_user_one white_list_block_user_one">
                {item?.img && <img src={`/img/user/${item?.img}.svg`} alt="" />}
                {/* { item?.color &&
                                    <div className='access_component_user_one_color' style={{background:`#${item?.color}`}}></div>
                                } */}
                <p>{item.name}</p>
                <span
                  className="access_component_user_one_delete-icon"
                  onClick={() => deleteUser(item.id)}>
                  <RxCross1 />
                </span>
              </div>
            ))}
          {/* <input type="text" placeholder='...' value={inputValueUser} onChange={(e) => {setInputValueUser(e.target.value)}} onKeyPress={handleKeyPressUser}  /> */}

          {showBtnUser ? (
            <SearchDropdownBtn setShowBtn={setShowBtnUser} />
          ) : (
            <SearchDropdown
              data={membersGlobalState?.data?.members}
              value={inputValueUser}
              setInputValue={setInputValueUser}
              setShowBtn={setShowBtnUser}
              handleSelectItem={addUser}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default WhiteListComponent;
